import React, { Component } from "react";
import CartLineItem from "./CartLineItem";
import CartUpsell from "./CartUpsell";

const CartList = ({ data, setShowDrawer, upsellCollection }) => {
  const { items, item_count, total_price } = data;

  if (items?.length < 1) {
    return (
      <div className="Loop Loop--minicart">
        <div className="empty-loop">You don't have any items in your bag.</div>
      </div>
    );
  } else {
    return (
      <div className="Drawer__contents">
        <div className="Loop Loop--minicart">
          {items.map((item, index) => (
            <CartLineItem product={item} key={`${item.id}-${index}`} />
          ))}
        </div>

        <ul className="MiniCart__totals">
          {data.total_discount > 0 && (
            <li className="discounts">
              <span className="label">Discounts</span>
              <span className="discount">
                ${(data.total_discount / 100).toFixed(2)}
              </span>
            </li>
          )}
          <li className="subtotal">
            <span className="label">Subtotal</span>
            <span className="total">
              ${(data.total_price / 100).toFixed(2)}
            </span>
          </li>
        </ul>
        <div className="MiniCart__notices">
          <div className="shipping">
            Shipping and Taxes calculated at checkout
          </div>
          {/* <div className="international-shipping">Notice: International Shipments may be subject to delays due to COVID-19.</div> */}
        </div>
        <form
          action="/cart"
          method="post"
          noValidate
          className="MiniCart__form"
        >
          <button
            className="Button continue-shopping"
            data-style="text"
            type="button"
            onClick={() => setShowDrawer(false)}
          >
            Continue Shopping
          </button>
          <button
            type="submit"
            name="cart"
            className="Button view-cart"
            data-style="solid purple block"
          >
            View Cart
          </button>
        </form>

        {upsellCollection ? (
          <CartUpsell
            collection={upsellCollection}
            cartTotal={total_price}
            cartItems={items}
            cardLayout="horizontal media-content"
          />
        ) : null}
      </div>
    );
  }
};
export default CartList;
